<script setup>

import AuthLayout from "../components/view-components/AuthLayout.vue";
</script>

<template>
  <AuthLayout show-legal>
    Přihlašování...
  </AuthLayout>
</template>

<style scoped lang="scss">

</style>
